import { render, staticRenderFns } from "./ApplicationTableCustomField.vue?vue&type=template&id=c8448188&"
import script from "./ApplicationTableCustomField.vue?vue&type=script&lang=js&"
export * from "./ApplicationTableCustomField.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationTableCustomField.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports